import z from "zod"
import { CapabilityIdentifier } from "./dtos"

export const CapabilityEvaluationSchema = z.object({
  capabilityId: z.string(),
  identifier: z.enum(CapabilityIdentifier),
  evaluationData: z.record(z.string(), z.unknown()),
  isDeflective: z.boolean().default(true),
  requiredForResolver: z.boolean().optional(),
  resolverFlow: z.boolean().optional(),
})

export type CapabilityEvaluation = z.infer<typeof CapabilityEvaluationSchema>

export const CapabilityEvaluationsSchema = z.array(CapabilityEvaluationSchema)

export const McpToolEvaluationSchema = z.object({
  selectedTool: z.string(),
  toolArguments: z.record(z.string(), z.unknown()),
  confidence: z.number().min(0).max(1),
})

export const McpCapabilityExecutionSchema = z.object({
  toolName: z.string(),
  toolArguments: z.record(z.string(), z.unknown()),
  result: z.record(z.string(), z.unknown()),
  executionTimeMs: z.number(),
  cached: z.boolean(),
})
